export const helpLink = "Hba";
export default {helpLink};